module.exports = __webpack_public_path__ + "media/images/logo-name-746b7f81782d5c497bb3fb1263693046.svg";